<template>
  <div class="ds-manager">
    <div
      class="ds-manager__header"
      v-if="activeComponent !== 'ds-manager-general'"
    >
      <ul class="ds-manager__navigation">
        <li
          class="ds-manager__navigation-item"
          @click="changeComponent(previousComponent)"
        >
          <i class="r-icon-arrow left" />
          <r-text :color="primaryColor">
            {{ $t(`ds-manager:navigation:item-name:${previousComponent}`) }}
          </r-text>
        </li>
      </ul>
    </div>

    <component
      v-if="
        activeComponent === 'ds-manager-menu' ||
          activeComponent === 'ds-manager-general' ||
          activeComponent === 'ds-manager-editor'
      "
      v-bind:is="activeComponent"
      :menuClickHandler="changeComponent"
    />
    <component v-else v-bind:is="activeComponent" />
    <el-button
      v-if="this.activeComponent === 'ds-manager-general'"
      class="r-button ds-manager__create-button"
      type="primary"
      size="mini"
      @click="changeComponent('ds-manager-menu')"
    >
      {{ $t("ds-manager:create-button") }}
    </el-button>
  </div>
</template>

<script>
import dsManagerGeneral from "./components/ds-manager-general";
import dsManagerMenu from "./components/ds-manager-creation/ds-manager-menu";
import dsManagerEmptyDs from "./components/ds-manager-creation/ds-manager-empty-ds";
import dsManagerEmptyModel from "./components/ds-manager-creation/ds-manager-empty-model";
import dsManagerFromFile from "./components/ds-manager-creation/ds-manager-from-file";
import dsManagerEditor from "./components/ds-manager-editor";

import variables from "@/styles/variables.scss";

export default {
  components: {
    dsManagerGeneral,
    dsManagerMenu,
    dsManagerEmptyDs,
    dsManagerEmptyModel,
    dsManagerFromFile,
    dsManagerEditor
  },
  data() {
    return {
      activeComponent: "",
      previousComponent: "",

      primaryColor: variables.primaryColor
    };
  },
  methods: {
    changeComponent(i) {
      switch (i) {
        case "ds-manger-general":
          this.previousComponent = "";
          break;
        case "ds-manager-menu":
        case "ds-manager-editor":
          this.previousComponent = "ds-manager-general";
          break;
        default:
          this.previousComponent = "ds-manager-menu";
          break;
      }
      this.activeComponent = i;
    }
  },
  created() {
    this.activeComponent = "ds-manager-general";
  }
};
</script>

<style lang="scss">
.ds-manager {
  position: relative;
  .ds-manager__create-button {
    position: absolute;
    top: 0;
    right: 0;
  }
  .ds-manager__header {
    margin: 0;
  }
  .ds-manager__navigation {
    margin-bottom: 16px;
    width: 100%;
    &-item {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      cursor: pointer;
      &:hover {
        filter: brightness(1.15);
      }
      .r-icon-arrow {
        &:before {
          border-color: var(--accent_primary) !important;
        }
      }
    }
  }
}
.ds-manager__component {
  position: relative;
  &-title {
    height: 44px;
  }
  &-content {
    width: 500px;
    position: relative;
    max-height: 50vh;
    height: 460px;
    overflow: hidden;
    overflow-y: auto;
  }
  &-subtitle {
    padding-bottom: 8px;
  }
  &-row {
    margin-bottom: 12px;
    .r-col {
      padding: 0 8px;
      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        padding-right: 0;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .text-center {
    text-align: center;
  }
  .text-right {
    text-align: right;
  }
}
</style>

<i18n>
{
  "ru": {
    "ds-manager:create-button": "Создать источник данных",
    
    "ds-manager:navigation:item-name:ds-manager-general": "Менеджер источников данных",
    "ds-manager:navigation:item-name:ds-manager-menu": "Меню создания источников данных"
  },
  "en": {
    "ds-manager:create-button": "Create data source",
    
    "ds-manager:navigation:item-name:ds-manager-general": "Data source manager",
    "ds-manager:navigation:item-name:ds-manager-menu": "Creating data sources menu"
  }
}
</i18n>
